/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import React from "react"
import { ShopProvider } from "./src/context/ShopContext"

// Envolver la aplicación con el proveedor del carrito
// El IntlProvider de gatsby-plugin-intl se envuelve automáticamente
export const wrapRootElement = ({ element }) => {
  return (
    <ShopProvider>
      {element}
    </ShopProvider>
  )
}

// Inicializar el modo oscuro cuando la página carga
export const onClientEntry = () => {
  // Código que se ejecuta cuando el cliente carga la página
  if (typeof window !== "undefined") {
    // Establecer modo oscuro por defecto
    document.body.classList.add("dark-mode")
  }
}
